import React, { useEffect, useState } from "react";
import { Row, Col, Image } from 'antd';
import { Link } from "react-router-dom";
import sal from 'sal.js';
import TeamPhoto from '../../media/pageQuiSommesNous/team-photo.webp';
import QuentinPhoto from '../../media/pageQuiSommesNous/quentin.webp';
import PierrePhoto from '../../media/pageQuiSommesNous/pierre.webp';
import DominiquePhoto from '../../media/pageQuiSommesNous/dominique.webp';
import AlexPhoto from '../../media/pageQuiSommesNous/alex.webp';
import ChloePhoto from '../../media/pageQuiSommesNous/chloe.webp';
import QuentinProfil from '../../media/pageQuiSommesNous/quentin-profil.webp';
import DominiqueProfil from '../../media/pageQuiSommesNous/dominique-profil.webp';
import { ReactComponent as SolutionIcone } from '../../media/pageQuiSommesNous/icone_solution.svg';
import { ReactComponent as EngagementIcone } from '../../media/pageQuiSommesNous/icone_engagement.svg';
import './QuiSommesNousScreen.css';

const MEMBRES = [
  {
    id: 'quentin',
    src: QuentinPhoto,
    nom: 'Quentin Nocture',
    linkedin: 'https://fr.linkedin.com/in/quentin-nocture-83860a286?trk=people-guest_people_search-card',
    zIndex: 2,
    hotspot: { left: '31%', top: '22%', width: '14%', height: '22%' },
  },
  {
    id: 'pierre',
    src: PierrePhoto,
    nom: 'Pierre Flamant',
    linkedin: 'https://fr.linkedin.com/in/pierre-flamant?trk=people-guest_people_search-card',
    zIndex: 2,
    hotspot: { left: '55%', top: '21%', width: '16%', height: '17%' },
  },
  {
    id: 'dominique',
    src: DominiquePhoto,
    nom: 'Dominique Nguyen',
    linkedin: 'https://fr.linkedin.com/in/dominique-nguyen-19893742?trk=people-guest_people_search-card',
    zIndex: 2,
    hotspot: { left: '73%', top: '40%', width: '17%', height: '18%' },
  },
  {
    id: 'alex',
    src: AlexPhoto,
    nom: 'Alex Lecointe',
    linkedin: 'https://fr.linkedin.com/in/alex-lecointe-705aab54?trk=people-guest_people_search-card',
    zIndex: 2,
    hotspot: { left: '7%', top: '36%', width: '14%', height: '23%' },
  },
  {
    id: 'chloe',
    src: ChloePhoto,
    nom: 'Chloé Lecointe',
    linkedin: 'https://fr.linkedin.com/in/chlo%C3%A9-lecointe-298600170?trk=people-guest_people_search-card',
    zIndex: 2,
    hotspot: { left: '44%', top: '44%', width: '16%', height: '20%' },
  },
];

const EVENEMENTS = [
    {
    annee: 2026,
    items: [
      { key: 'mieux-2026', nom: 'Émission Mieux — France TV', ville: 'Paris', date: '16 avril 2026', photos: [
        require('../../media/pageQuiSommesNous/evenements/mieux-2026-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/mieux-2026-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/mieux-2026-3.webp'),
      ]},
      { key: 'cnmst-2026', nom: 'CNMST', ville: 'Lyon', date: '2-5 juin 2026', photos: [
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-3.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-4.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-5.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-6.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2026-7.webp'),
      ]},
    ],
  },
  {
    annee: 2025,
    items: [
      { key: 'jbtp-2025', nom: 'JBTP', ville: 'Tours', date: '4-6 juin 2025', photos: [
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-3.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-4.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-5.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-6.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-7.webp'),
        require('../../media/pageQuiSommesNous/evenements/jbtp-2025-8.webp'),
      ]},
      { key: 'jef-2025', nom: 'JEF', ville: 'Strasbourg', date: '11-13 juin 2025', photos: [
        require('../../media/pageQuiSommesNous/evenements/jef-2025-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/jef-2025-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/jef-2025-3.webp'),
        require('../../media/pageQuiSommesNous/evenements/jef-2025-4.webp'),
      ]},
    ],
  },
  {
    annee: 2024,
    items: [
      { key: 'talents-esante-2024', nom: 'Talents de la e-santé', ville: 'Paris', date: 'Déc. 2024', photos: [
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-3.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-4.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-5.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-6.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-7.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-8.webp'),
        require('../../media/pageQuiSommesNous/evenements/talents-esante-2024-9.webp'),
      ]},
      { key: 'cnmst-2024', nom: 'CNMST', ville: 'Montpellier', date: 'Juin 2024', photos: [
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-1.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-2.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-3.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-4.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-5.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-6.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-7.webp'),
        require('../../media/pageQuiSommesNous/evenements/cnmst-2024-8.webp'),
      ]},
    ],
  },
];

function QuiSommesNousScreen() {
  const [anneeActive, setAnneeActive] = useState(EVENEMENTS[0].annee);
  const [evenementOuvert, setEvenementOuvert] = useState(null);
  const [hoveredMembre, setHoveredMembre] = useState(null);

  useEffect(() => {
    sal();
  }, []);

  const annees = EVENEMENTS.map(e => e.annee);
  const itemsActifs = EVENEMENTS.find(e => e.annee === anneeActive)?.items || [];

  return (
    <div className="qsn-page">

      {/* ── HERO ── */}
      <section className="qsn-hero">
        <div className="qsn-inner">
          <Row align="middle" gutter={[48, 40]}>
            <Col xs={24} lg={12} data-sal="slide-up" data-sal-duration="500">
              <h1 className="qsn-hero-title">Qui sommes-nous ?</h1>
              <p className="qsn-hero-intro">
                RAVAIL est une start-up fondée en 2023 par cinq fondateurs, unis par une conviction commune : mettre l’innovation digitale au service de la santé au travail.
              </p>
              <div className="qsn-stats">
                <div className="qsn-stat">
                  <span className="qsn-stat-number">5</span>
                  <span className="qsn-stat-label">fondateurs</span>
                </div>
                <div className="qsn-stat">
                  <span className="qsn-stat-number">2023</span>
                  <span className="qsn-stat-label">création de RAVAIL</span>
                </div>
              </div>
            </Col>
            <Col xs={24} lg={12} className="qsn-hero-photo-col" data-sal="slide-left" data-sal-duration="700">
              <div className={`qsn-team-photo-wrap${hoveredMembre ? ' qsn-team-photo-wrap--hovered' : ''}`}>
                {/* Fond */}
                <img src={TeamPhoto} alt="L'équipe RAVAIL" className="qsn-team-layer qsn-team-bg" />

                {/* PNGs — cachés par défaut, visibles quand la personne est survolée */}
                {MEMBRES.map(m => (
                  <img
                    key={m.id}
                    src={m.src}
                    alt={m.nom}
                    className={`qsn-team-layer qsn-person-png${hoveredMembre === m.id ? ' qsn-person-png--visible' : ''}`}
                    style={{ zIndex: m.zIndex }}
                  />
                ))}

                {/* Zones hotspot — clic = LinkedIn, hover = nom affiché en bas */}
                {MEMBRES.map(m => (
                  <a
                    key={m.id}
                    href={m.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="qsn-person-hotspot"
                    style={{ ...m.hotspot, zIndex: 10 }}
                    onMouseEnter={() => setHoveredMembre(m.id)}
                    onMouseLeave={() => setHoveredMembre(null)}
                    aria-label={m.nom}
                  />
                ))}

                {/* Nom centré en bas */}
                {hoveredMembre && (
                  <div className="qsn-person-tooltip">
                    <span className="qsn-person-nom">{MEMBRES.find(m => m.id === hoveredMembre).nom}</span>
                    <span className="qsn-person-linkedin-hint">Cliquer pour LinkedIn →</span>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <div className="wave-qsn-to-content" aria-hidden="true">
        <svg viewBox="0 0 1280 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 120 H1280 V60 C1000 0 300 120 0 40 Z" fill="#fefefe"/>
        </svg>
      </div>

      {/* ── ORIGINE DU PROJET ── */}
      <section className="qsn-section qsn-section--origine">
        <div className="qsn-inner">
          <h2 className="qsn-section-title qsn-origine-heading" data-sal="slide-up" data-sal-duration="500">À l'origine du projet</h2>
          <Row gutter={[48, 40]} align="middle">
            <Col xs={24} md={14} data-sal="slide-up" data-sal-duration="600" data-sal-delay="100">
              <p className="qsn-origine-text">Le logiciel développé par Ravail, initialement appelé Easy VFC, est né d'un travail de thèse mené par le Dr Quentin Nocture, sous la direction du Dr Dominique Nguyen.</p>
              <p className="qsn-origine-text">À la suite de la loi du 2 août sur la santé au travail, leur recherche visait à mieux structurer l'analyse des expositions professionnelles afin d'aider les médecins et infirmiers à déterminer les suivis adaptés pour les salariés exposés à des risques d'effets différés.</p>
              <p className="qsn-origine-text">Une première étape a conduit à la création d'une trentaine de guides d'exposition au format papier. Mais la complexité des parcours professionnels et l'évolution rapide des connaissances scientifiques ont rapidement montré les limites de ce format.</p>
              <p className="qsn-origine-text">C'est ainsi qu'est née l'idée de développer un outil numérique dédié, capable d'accompagner les professionnels de santé dans l'analyse des expositions tout au long de la carrière des salariés.</p>
            </Col>
            <Col xs={24} md={10}>
              <div className="qsn-origine-portraits">
                <div className="qsn-origine-portrait" data-sal="slide-left" data-sal-duration="500" data-sal-delay="200">
                  <div className="qsn-origine-portrait-circle">
                    <img src={DominiqueProfil} alt="Dr Dominique Nguyen" className="qsn-origine-portrait-img" />
                  </div>
                  <span className="qsn-origine-portrait-nom">Dr Dominique Nguyen</span>
                </div>
                <div className="qsn-origine-portrait" data-sal="slide-left" data-sal-duration="500" data-sal-delay="400">
                  <div className="qsn-origine-portrait-circle">
                    <img src={QuentinProfil} alt="Dr Quentin Nocture" className="qsn-origine-portrait-img" />
                  </div>
                  <span className="qsn-origine-portrait-nom">Dr Quentin Nocture</span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* ── SERVICES & ENGAGEMENT ── */}
      <section className="qsn-section">
        <div className="qsn-inner">
          <Row gutter={[40, 32]}>
            <Col xs={24} md={12} data-sal="slide-up" data-sal-duration="600">
              <div className="qsn-card qsn-card--blue">
                <SolutionIcone className="qsn-card-icon" aria-hidden="true" />
                <h2 className="qsn-card-title">Nos services</h2>
                <p className="qsn-card-text">
                  Nos solutions accompagnent médecins et infirmiers dans la détection et l’évaluation des expositions professionnelles afin d’offrir à chaque salarié un suivi personnalisé.
                </p>
              </div>
            </Col>
            <Col xs={24} md={12} data-sal="slide-up" data-sal-duration="600" data-sal-delay="150">
              <div className="qsn-card qsn-card--green">
                <EngagementIcone className="qsn-card-icon" aria-hidden="true" />
                <h2 className="qsn-card-title">Notre engagement</h2>
                <p className="qsn-card-text">
                  Engagés pour la santé publique, nous promouvons le dépistage, luttons contre la sous-déclaration des maladies professionnelles et développons des outils accessibles à tous. Notre modèle est indépendant et financé par nos solutions pour les services de santé au travail.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* ── ÉVÉNEMENTS ── */}
      <section className="qsn-section qsn-section--light">
        <div className="qsn-inner">
          <div className="qsn-events-header">
            <h2 className="qsn-section-title">Nos présences</h2>
            <p className="qsn-section-subtitle">Congrès et salons où nous vous avons rencontrés.</p>
          </div>
          <div className="qsn-events-layout">

            {/* Timeline */}
            <div className="qsn-timeline">
              {annees.map((annee, i) => (
                <React.Fragment key={annee}>
                  <button
                    className={`qsn-timeline-item${anneeActive === annee ? ' qsn-timeline-item--active' : ''}`}
                    onClick={() => { setAnneeActive(annee); setEvenementOuvert(null); }}
                  >
                    <span className="qsn-timeline-dot" />
                    <span className="qsn-timeline-year">{annee}</span>
                  </button>
                  {i < annees.length - 1 && <span className="qsn-timeline-line" />}
                </React.Fragment>
              ))}
            </div>

            {/* Cartes événements */}
            <div className="qsn-events-grid">
              {itemsActifs.map(ev => (
                <div key={ev.key} className="qsn-event-card" onClick={() => setEvenementOuvert(evenementOuvert === ev.key ? null : ev.key)}>
                  <div className="qsn-event-card-header">
                    <div>
                      <span className="qsn-event-nom">{ev.nom}</span>
                      <span className="qsn-event-meta">{ev.ville} · {ev.date}</span>
                    </div>
                    {ev.photos.length > 0 && (
                      <div className="qsn-event-thumbs">
                        {ev.photos.slice(0, 3).map((src, i) => (
                          <div key={i} className="qsn-event-thumb-wrap">
                            <img src={src} alt="" className="qsn-event-thumb" />
                            {i === 2 && ev.photos.length > 3 && (
                              <span className="qsn-event-thumb-more">+{ev.photos.length - 3}</span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                    <span className={`qsn-event-chevron${evenementOuvert === ev.key ? ' qsn-event-chevron--open' : ''}`}>›</span>
                  </div>
                  {evenementOuvert === ev.key && (
                    <div className="qsn-event-photos" onClick={e => e.stopPropagation()}>
                      {ev.photos.length > 0 ? (
                        <Image.PreviewGroup>
                          {ev.photos.map((src, i) => (
                            <Image key={i} src={src} alt={`${ev.nom} ${i + 1}`} className="qsn-event-photo" />
                          ))}
                        </Image.PreviewGroup>
                      ) : (
                        <p className="qsn-event-photos-empty">Photos à venir</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="qsn-cta">
        <div className="qsn-inner qsn-cta-inner">
          <h2 className="qsn-cta-title">Envie d'en savoir plus ?</h2>
          <div className="qsn-cta-actions">
            <Link to="/contact" className="qsn-cta-btn qsn-cta-btn--primary">Nous contacter</Link>
            <a href="https://www.linkedin.com/company/ravail" target="_blank" rel="noopener noreferrer" className="qsn-cta-btn qsn-cta-btn--secondary">LinkedIn</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default QuiSommesNousScreen;
